export interface IIqTrendlinesGraphLtStateService {}
import { ElementRef, InjectionToken } from '@angular/core';
import { z } from 'zod';

export const TL_GRAPH_LT_URL = new InjectionToken<string>('TL_GRAPH_LT_URL');

export const TRENDLINES_CACHE_DB = 'trendlines-cache';
export const TRENDLINES_VAN_LT_GRAPH_DOC = 'trendlines_van_lt_graph';
export const TRENDLINES_REEFER_LT_GRAPH_DOC = 'trendlines_reefer_lt_graph';
export const TRENDLINES_FLATBED_LT_GRAPH_DOC = 'trendlines_flatbed_lt_graph';

export const RatioSchema = z.object({
    date: z.date(),
    lt: z.number(),
});

export type Ratio = z.infer<typeof RatioSchema>;

export type RatioMap = {
    twoYearPast: Ratio[];
    oneYearPast: Ratio[];
    currentYear: Ratio[];
};

export interface IIqTrendlinesGraphLtStateService {
    flatbedGraph(container: ElementRef, ratioMap: RatioMap): void;
    reeferGraph(container: ElementRef<any>, ratioMap: RatioMap): void;
    vanGraph(container: ElementRef<any>, ratioMap: RatioMap): void;
    vanData(): Promise<RatioMap>;
    reeferData(): Promise<RatioMap>;
    flatbedData(): Promise<RatioMap>;
}

export const threeYearMonthlySchema = z.object(
    {
        monthAndYearWhen: z.string(),
        truckCount: z.number(),
        loadCount: z.number(),
        ratio: z.number(),
    }
);

export const oneMonthWeeklySchema = z.object({
    weekEndingWhen: z.string(),
    truckCount: z.number(),
    loadCount: z.number(),
    ratio: z.number(),
});

export const LoadTruckResponseSchema = z.object({
    threeYearMonthly:z.array(threeYearMonthlySchema),
    oneMonthWeekly: z.array(oneMonthWeeklySchema),
});

export type ThreeYearMonthly = z.infer<typeof threeYearMonthlySchema>;

export type LoadTruckResponse = z.infer<typeof LoadTruckResponseSchema>;

